export default __webpack_public_path__ + "static/media/ulucinar10.1d8ad32c.jpg";